import { IIntelliUploadProcessDocumentsRequest, IIntelliUploadProcessDocumentsResponse, IIntelliUploadRepository } from "@/core/repositories/intelli-upload";

export class ProcessDocumentsUseCase {
  constructor(private readonly intelliUploadRepository: IIntelliUploadRepository) {}

  async execute(request: IIntelliUploadProcessDocumentsRequest): Promise<IIntelliUploadProcessDocumentsResponse> {
    return this.intelliUploadRepository.processDocuments(request);
  }
}
